import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";

const supportTicketsApi = factory.get("supportTickets");

const initialState = {
  tickets: {
    loading: false,
    data: [],
    total: 0,
    filters: {
      page: 0,
      skip: 0,
      take: 15,
      search: "",
      status: null,
    },
    dialog: false,
  },
  ticketDetail: {
    loading: false,
    data: null,
  },
  addComment: {
    loading: false,
  },
  updateStatus: {
    loading: false,
  },
};

export const supportTicketsSlice = createSlice({
  name: "supportTickets",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const [key, subKey] = action.payload.split(".");
      if (subKey) {
        state[key][subKey] = !state[key][subKey];
      } else {
        state[key].loading = !state[key].loading;
      }
    },
    setTickets: (state, { payload }) => {
      state.tickets.data = payload.data;
      state.tickets.total = payload.total;
    },
    setFilters: (state, { payload }) => {
      state.tickets.filters = {
        ...state.tickets.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.tickets.filters = initialState.tickets.filters;
    },
    setFiltersDialog: (state) => {
      state.tickets.dialog = !state.tickets.dialog;
    },
    setTicketDetail: (state, { payload }) => {
      state.ticketDetail.data = payload;
    },
    clearTicketDetail: (state) => {
      state.ticketDetail.data = null;
    },
  },
});

export const {
  setLoading,
  setTickets,
  setFilters,
  resetFilters,
  setFiltersDialog,
  setTicketDetail,
  clearTicketDetail,
} = supportTicketsSlice.actions;

export default supportTicketsSlice.reducer;

const index = () => async (dispatch, getState) => {
  try {
    const filters = getState().supportTickets.tickets.filters;
    const _filters = {
      skip: filters.skip,
      take: filters.take,
      search: filters.search || undefined,
      status: filters.status?.value || undefined,
    };
    dispatch(setLoading("tickets"));
    const res = await supportTicketsApi.index(_filters);
    dispatch(setTickets(res.data));
    dispatch(setLoading("tickets"));
  } catch (err) {
    dispatch(setLoading("tickets"));
    console.log(err);
  }
};

const show = (id) => async (dispatch) => {
  try {
    dispatch(setLoading("ticketDetail"));
    const res = await supportTicketsApi.show(id);
    dispatch(setTicketDetail(res.data?.data?.[0] || null));
    dispatch(setLoading("ticketDetail"));
  } catch (err) {
    dispatch(setLoading("ticketDetail"));
    dispatch(
      showNotification({
        type: "error",
        message: "Failed to load ticket details",
      })
    );
    console.log(err);
  }
};

const updateStatus = (id, status) => async (dispatch) => {
  try {
    dispatch(setLoading("updateStatus"));
    await supportTicketsApi.updateStatus(id, { status });
    dispatch(setLoading("updateStatus"));
    dispatch(
      showNotification({
        type: "success",
        message: "Ticket status updated successfully",
      })
    );
    dispatch(show(id));
  } catch (err) {
    dispatch(setLoading("updateStatus"));
    dispatch(
      showNotification({
        type: "error",
        message: err?.response?.data?.errors?.[0] || "Failed to update status",
      })
    );
    console.log(err);
  }
};

const addComment = (id, comment) => async (dispatch) => {
  try {
    dispatch(setLoading("addComment"));
    await supportTicketsApi.addComment(id, { comment });
    dispatch(setLoading("addComment"));
    dispatch(
      showNotification({
        type: "success",
        message: "Comment added successfully",
      })
    );
    dispatch(show(id));
  } catch (err) {
    dispatch(setLoading("addComment"));
    dispatch(
      showNotification({
        type: "error",
        message: err?.response?.data?.errors?.[0] || "Failed to add comment",
      })
    );
    console.log(err);
  }
};

export const SupportTickets = {
  index,
  show,
  updateStatus,
  addComment,
};
